import { render } from "./Agents.vue?vue&type=template&id=1caf4f4b&scoped=true&lang=pug"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"

import "./Agents.vue?vue&type=style&index=0&id=1caf4f4b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf4f4b"]])

export default __exports__